'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RequestManager = undefined;

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isFunction = require('d2-utilizr/lib/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayTo = require('d2-utilizr/lib/arrayTo');

var _arrayTo2 = _interopRequireDefault(_arrayTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequestManager = exports.RequestManager = undefined;

exports.RequestManager = RequestManager = function RequestManager(refs, config) {
    var t = this;

    config = (0, _isObject2.default)(config) ? config : {};

    // constructor
    t.requests = (0, _isArray2.default)(config.requests) ? config.requests : [];

    t.responses = [];

    t.fn = (0, _isFunction2.default)(config.fn) ? config.fn : function () {
        console.log('Request manager done');
    };

    t.fnParams = [];
};

RequestManager.prototype.add = function (param) {
    var t = this,
        requests = (0, _arrayFrom2.default)(param);

    requests.forEach(function (request) {
        request.setManager(t);
    });

    this.requests = [].concat(this.requests, requests);
};

RequestManager.prototype.set = function (fn, params) {
    this.fn = fn;

    if (params) {
        this.fnParams = params;
    }
};

RequestManager.prototype.ok = function (xhr, suppress) {
    this.responses.push(xhr);

    if (!suppress) {
        this.resolve();
    }
};

RequestManager.prototype.run = function () {
    this.requests.forEach(function (request) {
        request.run();
    });
};

RequestManager.prototype.resolve = function () {
    if (this.responses.length === this.requests.length) {
        this.fn(this.fnParams);
    }
};

RequestManager.prototype.applyTo = function (modules) {
    var t = this;

    (0, _arrayTo2.default)(modules).forEach(function (module) {
        module.requestManager = t;
    });
};
//# sourceMappingURL=RequestManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/manager/RequestManager.js
 ** module id = 134
 ** module chunks = 0 1
 **/